import policyDialog from './index.vue';
 
// 定义插件对象
const PolicyDialog = {};
// vue的install方法，用于定义vue插件
PolicyDialog.install = function (Vue, options) {
  const PolicyDialogInstance = Vue.extend(policyDialog);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new PolicyDialogInstance();
    let msgBoxEl = currentMsg.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$policyDialog = {
    showPolicyDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      if (typeof options === 'string') {
        currentMsg.content = options;
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options);
      }
      currentMsg.showMsgBox();
    }
  };
};
 
export default PolicyDialog;


// WEBPACK FOOTER //
// ./src/components/common/policy-dialog/index.js